import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components'
import {CheckMarkIcon, CloseIcon} from 'components/static/icons'
import Color from 'constants/colors'

const UI_STATE = {
	LOADING: 0,
  PRIVATE: 1,
  CONFIRM_PENDING: 2,
  MAKE_PUBLIC_PENDING: 3,
  PUBLIC: 4,
}

const ConfirmContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: no-wrap;
  padding: 0 10px;
  margin-right: 10px;
`;

const Icon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  margin: 0 2px;
`;

const SharedSpan = styled.div`
  font-family: ${props=>props.theme.fonts.h5};
	display: inline-block;
  font-size: 14px;
	color: ${Color('purple')};
  cursor: pointer;
`;

const Label = styled.span`
  font-family: ${props=>props.theme.fonts.h5};
  font-size: ${props=>props.verbose?"16px":"12px"};
  text-transform: none;
  display: inline-block;
`;

const VisibilityLabel = styled.h5`
  text-align: left;
  margin: 0;
`;

const Emoji = styled.span`
  font-size: 16px;
`;


class ShareToggle extends React.Component {
	constructor(props) {
		super(props);
		// props.shared likely to be undefined
		const toggleState = 
			(	props.shared !== undefined) ? this.mapSharedToUI(props.shared) : UI_STATE.PRIVATE;
		this.state = {
			toggleState: toggleState,
			shared: props.shared,
		};
	}

  //-- this seems questionable
  componentWillMount() {
    this.componentWillUpdate(this.props)
  }

	componentWillUpdate(nextProps) {
		const votePref = this.getVotePref(nextProps.votePrefs)
		const shared = votePref.data ? votePref.data.shared : undefined;
		if(this.state.shared !== shared) {
			this.setState({
				shared: shared,
				toggleState: this.mapSharedToUI(shared),
			})
		}
	}

	mapSharedToUI = (sharedState) => {
		if(sharedState) return UI_STATE.PUBLIC;
		if(sharedState === false) return UI_STATE.PRIVATE;
		return UI_STATE.LOADING; //--previously was loading
	}

  cancel = () => {
    this.setState({toggleState: UI_STATE.PRIVATE})
  }

  changeShared = (value) => {
    const { store } = this.context;
    const userId = this.props.userId || this.props.user.userId;

    store.dispatch({
      type: "WRITE_VOTE_PREF_REQUESTED",
      payload: {
        pageId: this.props.pageId,
        userId: userId,
        data: {
          shared: value,
        },
      }
    });
    this.setState({toggleState: UI_STATE.MAKE_PUBLIC_PENDING})
  }

  confirmPending = () => {
    this.setState({
      toggleState: UI_STATE.CONFIRM_PENDING
    });
  }

  getVotePref = (votePrefs) => {
  	const pageId = this.props.pageId;
  	const userId = this.props.user.userId;
  	const key = `${pageId}#${userId}`;
  	return votePrefs[key] || { data: { shared: undefined } };
  }

  render() {
    let toDisplay = null;
    const {verbose} = this.props;
    switch(this.state.toggleState) {
  		case UI_STATE.LOADING:
				toDisplay = <span>...</span>;
        break;
      case UI_STATE.PRIVATE:
        toDisplay = (
        	<React.Fragment>
						<Label
							onClick={verbose ? ()=>{}: this.confirmPending }
							verbose={verbose}
						>
	           {verbose ? 
                <VisibilityLabel>This page, your notes and annotations, are only visible to you.</VisibilityLabel>
                : 
                <Emoji><span role="img" aria-label="private">🔒</span></Emoji>
              }
						</Label>
	          <SharedSpan
	            onClick={verbose ? this.confirmPending : ()=>{} }>
	            {verbose ? 
                "(Click to make public)" 
                : 
                null
              }
	          </SharedSpan>
        	</React.Fragment>
        );
        break;
      case UI_STATE.CONFIRM_PENDING:
        toDisplay = (
          <ConfirmContainer>
            <Label>
          		Make page public?
          	</Label>
            <Icon onClick={this.cancel}><CloseIcon color="crimson"/></Icon>
            <Icon onClick={() => this.changeShared(true)}>
              <CheckMarkIcon color="darkgreen"/>
            </Icon>
          </ConfirmContainer>
        );
        break;
      case UI_STATE.MAKE_PUBLIC_PENDING:
        toDisplay = <Label>hold on...</Label>
        break;
      case UI_STATE.PUBLIC:
        toDisplay = (
        	<React.Fragment>
	          <Label 
	          	onClick={verbose ? ()=>{}: () => this.changeShared(false) }
	          	verbose={verbose}
          	>
	           	{this.props.verbose ? 
                <VisibilityLabel>This page, your notes and annotations, are visible to anyone with the link</VisibilityLabel>
                : 
                <Emoji role="img" aria-label="shared">👁</Emoji>
              }
	          </Label>
	          <SharedSpan onClick={verbose ? () => this.changeShared(false) : ()=>{} }>
	            { verbose ?  
                <span role="img" aria-label="private">Click to make private 🔒</span> 
              : 
              null 
              }
	          </SharedSpan>
        	</React.Fragment>
        );
        break;
      default:
        break;
    }
    return(
      toDisplay
    );
  }
}

ShareToggle.contextTypes = {
  store: PropTypes.object
};

// this should be required but due to parent level problems
// this gets set to undefined while loading
ShareToggle.propTypes = {
  pageId: PropTypes.string.isRequired,
  userId: PropTypes.string,
  verbose: PropTypes.bool,
};

ShareToggle.defaultProps = {
	verbose: true,
}

function mapStateToProps(state) {
  const user = state.user.data || {};
  const { votePrefs } = state;

  return { user, votePrefs };
}

export default connect(mapStateToProps, {})(withRouter(ShareToggle));




// WEBPACK FOOTER //
// ./src/pages/user/shareToggle.js